import {
  type NavigateOptions,
  useLocation,
  useNavigate,
} from "react-router-dom";

import { useToast } from "@/hooks/use-toast";
import { parseError } from "@/lib/error-handler";
import { navigateToLogin } from "@/lib/routing";

export const useErrorHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();

  const handleMutationError = (error: unknown) => {
    const { title, message } = parseError(error);
    toast({
      title: title,
      description: message,
      variant: "destructive",
    });
  };

  return {
    handleUnauthenticatedUser: (options: NavigateOptions = {}) => {
      navigateToLogin(location, options, (path, navigateOptions) => {
        void navigate(path, navigateOptions);
      });
    },
    handleMutationError,
  };
};
